import React, { Component } from 'react';



class Footer extends Component {
    render() {
        return (
            <div className="container">
                <div className="copyright">
                    <p>Copyright @ 2017 EsportsWire.net</p>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/footer.js